<div cdkDrag [cdkDragData]="data">
    <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
    <div [id]="data.id" 
        class="widget-area"
        [ngClass]="data.isSelected ? 'widget-selected' : 'widget-unselected'"
        cdkDropList
        [cdkDropListConnectedTo]="dropListIds"
        [cdkDropListData]="data.children"
        [cdkDropListEnterPredicate]="isDroppableWidget"
        (cdkDropListDropped)="onDrop($event)">

        <!-- Titlebar for Widget -->         
        <div class="widget-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">
            <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon>                   
            <mat-label class="top-bar-title" fxFlex="grow" (click)="onSelect($event)"><b>{{data.name}}</b></mat-label>
            <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
            <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">expand_less</mat-icon>
            <mat-icon *ngIf="isMinimized" class="top-icon" (click)="onMaximize()">expand_more</mat-icon>    
        </div>

        <!-- Config data for Widget --> 
        <div *ngIf="!isMinimized" fxLayout="row nowrap">
            <appMetadataWidget fxFlex="grow" [data]="data"></appMetadataWidget>
        </div>        

        <!-- Allowed drops -->
        <div fxLayout="row nowrap">
        <ng-container *ngFor="let widget of data.children">
            <ng-container [ngSwitch]="widget.widgetType">                
                <div appWidgetsColumn                    
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    [fxFlex]="$any(widget).width"
                    (dropListIdAdded)="onDropListIdAdded($event)"
                    *ngSwitchCase="WidgetsTypeEnum.COLUMN">
                </div>        
            </ng-container>
        </ng-container>
        </div>                            
    </div>
</div>
